import React, { Component, Fragment } from 'react';
import { elements } from './_data_safety_layout';
import DayProductiveElement from './DayProductiveElement';
import '@app/components/sqdp/cbm/styles/productive-layout.css';
import dayjs from 'dayjs';
import { getDayColorError, getDayColorGood, getDayColorWarn } from '@app/services/localStorage.service';

class ProductiveLayout extends Component {
  state = {
    showInfo: false,
    element: {},
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 4, 'cbm');
  };

  getColorOfDay = (issueOfDay, dateNum) => {
    if (!issueOfDay) return 'emtpy_state';

    const {
      isRestDay,
      highestProductivityProductionDownTimeMinutes = 0,
      countProductivityTotal = 0,
      countProductivityIsStopProduce = 0,
    } = issueOfDay;

    const thisDay = dayjs().date(dateNum).day();
    const today = dayjs();
    const selectedTime = dayjs(this.props.selectedMonth);

    // ⛱ Ngày nghỉ cuối tuần
    if (isRestDay && (thisDay === 6 || thisDay === 0)) {
      return 'emtpy_state';
    }
    if (
      today.get('month') <= selectedTime.get('month') &&
      today.get('year') <= selectedTime.get('year') &&
      dateNum > today.get('date')
    ) {
      return 'emtpy_state';
    }

    // 🔴 Có thời gian dừng sản xuất > 30
    if (highestProductivityProductionDownTimeMinutes > 30) {
      return 'red_state';
    }

    // 🟢 Không dừng sản xuất (= 0)
    if (highestProductivityProductionDownTimeMinutes === 0) {
      return 'green_state';
    }

    // 🟡 Có thời gian dừng sản xuất
    return 'yellow_state';
  };

  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDay = this.props.dataInMonth[i - 1];
      let color = this.getColorOfDay(issueOfDay, i);
      items.push(
        <DayProductiveElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          num={i}
          color={color}
          issues={issueOfDay}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      // <div className="wrapper">
      <>
        <div id="table-productive">
          {/* Elements 1-4 */}
          {this.populateElements(1, 32)}
          {/* Information Table */}
          {/* {this.state.showInfo && (
            <Fragment>
              <div id="element-box" className={`${category}`}>
                <div className="number">{number}</div>
                <div className="symbol">{symbol}</div>
                <div className="element-name">{name}</div>
              </div>
              <div id="information">
                <div
                  onClick={this.closeInfo}
                  className="close-button"
                  title="Close Info"
                >
                  Close [&times;]
                </div>
                <div>
                  <h1 className="big_title">{name}</h1>
                  <span className={`cat_name ${category}`}>{category}</span>
                  {appearance && (
                    <div className="appearance">
                      <strong>Appearance:</strong> {appearance}
                    </div>
                  )}
                  <div className="atom_info">
                    <span>Atomic Mass: {atomic_mass} | </span>
                    <span>Density: {density}</span>
                    {molar_heat && <span> | Molar Heat: {molar_heat}</span>}
                    {melt && <span> | Melt: {melt}K</span>}
                    {boil && <span> | Boil: {boil}K</span>}
                  </div>
                  <div>
                    {summary} ...{" "}
                    <a target="_blank" href={source}>
                      Source
                    </a>
                  </div>
                </div>
              </div>
            </Fragment>
          )} */}

          {/* {this.populateElements(5, 57)}
          {this.populateElements(72, 89)}
          {this.populateElements(104, 118)}
          {this.populateElements(58, 71)}
          {this.populateElements(90, 103)} */}
        </div>
        <h3 className="center" style={{ paddingLeft: '50px', marginTop: '20px' }}>
          Productivity
        </h3>
      </>
    );
  }
}

export default ProductiveLayout;
